<template>
<div class="serviceProviderEditDialog form">
    <el-dialog @close='cancel' title="申请服务商" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="头像" class="upload-image content" prop="logourl" required>
                <div class="upload sponsor-logo" @click="openLocalGallery">
                    <div class="avatar-uploader">
                        <div tabindex="0" class="el-upload el-upload--text">
                            <i class="avatar-uploader-icon user_default_image"
                               v-if="!item.logourl"></i>
                            <img :src="item.logourl+'?'+timestamp" alt="" class="avatar"
                                 v-if="item.logourl">
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="服务商名称" prop="name" class="content">
                <el-input v-model.trim="item.name" placeholder="请输入名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="linkman" class="content">
                <el-input v-model.trim="item.linkman" placeholder="请输入联系人" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="linktel" class="content">
                <el-input v-model.trim="item.linktel" placeholder="请输入联系人电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="smscode" class="content">
                <el-input v-model.trim="item.smscode" placeholder="请输入验证码" clearable class="smscode"></el-input>
                <el-button type="primary" @click="getSmscode" plain class="smscode-button">{{timer.countdown ? timer.num : '获取验证码'}}</el-button>
            </el-form-item>
            <el-form-item label="简介" prop="description" class="content">
                <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="item.description" clearable resize="none"></el-input>
            </el-form-item>
            <el-form-item class="form-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage"
                  :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import {saveProviderHostRoleInfo} from 'api/brandBusiness'
import {sendVerCode} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import LocalCropper from 'base/cropper/localCropper'
export default {
    name: 'serviceProviderEditDialog',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择头像'))
            } else {
                callback()
            }
        }
        return {
            timer: {
                countdown: false,
                num: 60
            },
            timestamp: new Date().getTime(),
            cropperOption: {
                fixedNumber: [80, 80], // 截图框的宽高比例
                enlarge: 0.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 80, // 默认生成截图框宽度
                autoCropHeight: 80 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            dialogVisible: false,
            flag: 'add',
            item: {
                description: '',
                hostroletype: 4,
                inviteid: '',
                inviteisauth: '',
                inviteroletype: '',
                invitetobrandid: '',
                ischangehead: '',
                linkman: '',
                linktel: '',
                logokeyid: '',
                logourl: '',
                name: '',
                rolehostinnerid: '',
                smscode: ''
            },
            rules: {
                logourl: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                smscode: [
                    {required: true, message: '请输入验证码', trigger: 'blur'}
                ],
                linkman: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                linktel: [
                    {pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'},
                    {required: true, message: '请输入联系人电话', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        // 发送手机验证码
        getSmscode() {
            if (this.timer.countdown) return false
            let reg = /^1[3|4|5|7|8][0-9]{9}$/ // 手机号验证规则
            if (!this.item.linktel) {
                this.$message.error('请输入手机号')
            } else if (!reg.test(this.item.linktel)) {
                this.$message.error('请输入正确的手机号码')
            } else {
                this.setLoading(true)
                sendVerCode({
                    data: {
                        mobileno: this.item.linktel,
                        smstype: '1'
                    },
                    success: data => {
                        this.setLoading(false)
                        this.countdown()
                        this.$message.success(data.msg)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 倒计时
        countdown () {
            this.timer.countdown = true
            let _this = this
            let timer = setInterval(() => {
                _this.timer.num--
            }, 1000)
            setTimeout(() => {
                clearInterval(timer)
                _this.timer.countdown = false
            }, 60000)
        },
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.item.logourl = file.furl
            this.item.logokeyid = file.key
        },
        openDialog(flag) {
            this.dialogVisible = true
            this.flag = flag
        },
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            saveProviderHostRoleInfo({
                data: Object.assign({}, this.item),
                success: data => {
                    console.log(data.data)
                    let user = this._.cloneDeep(this.user)
                    console.log(user.isprovider)
                    user.providerinnerid = data.data
                    user.isprovider = 1
                    console.log(user.isprovider)
                    this.setUser(this._.cloneDeep(user))
                    sessionStorage.setItem('user', JSON.stringify(user))
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            saveHostRoleInfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
.serviceProviderEditDialog {
    .title{
        color:  #F56C6C ;
        font-size: 14px;
        margin-bottom: 30px;
    }
    .user_default_image{
        width: 80px;
        height: 80px;
    }
    .content{
        display: flex;
        align-items: center;
    }
    .el-input{
        line-height: 1;
    }
    .el-form-item__content{
        margin-left: 20px !important;
        display: flex;
        align-items: center;
        .smscode{
            width: 140px;
            margin: 0 20px 0 0;
        }
        .smscode-button{
            margin:0;
        }
        .el-textarea{
            width: 460px !important;
            height: 54px;
        }
    }
    .el-form-item__label{
        text-align: right;
    }
    .form-footer{
        display: flex;
        justify-content: center;
    }
}
</style>
